import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./sidebare.css";
import Logo from "../IMG/Logo.png";
import GetNotificationAdminNoRead from "../../../Services/Admin/GetNotificationAdminNoRead";
import { NotificationMagasinType } from "../../../Modeles/NotificationModel";
import { NotificationType } from "../notification/NotificationAdmin";
import DemandesAdmin from "../../../Services/Admin/DemandesAdmin";
import SideBarMobile from "./SideBarMobile";

export default function Sidebare() {
  const location = useLocation();
  const [activeItem, setActiveItem] = useState<string | null>(null);
  const [state, setState] = useState<any>("");
  const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth);
  const [show, setShow] = useState(false);
  const [problem, setProblem] = useState("");
  const [description, setDescription] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log({ problem, description });
    // 🚀 Ici tu peux appeler ton API pour créer un ticket
    setShow(false);
  };
  const [stateNotification, setStateNotification] = useState<NotificationType>({
    Notifications: [] as NotificationMagasinType[],
    messageErrosNotif: "aucune Notification",
  });

  // Fetch notifications

  useEffect(() => {
    setStateNotification({ ...stateNotification });
    GetNotificationAdminNoRead()
      .GetNotification()
      .then((res) =>
        setStateNotification({ ...stateNotification, Notifications: res.data })
      )
      .catch((msg) =>
        setStateNotification({
          ...stateNotification,
          Notifications: msg.messageErrosNotif,
        })
      );
  }, []);

  const { Notifications, messageErrosNotif } = stateNotification;

  // Track active menu item
  useEffect(() => {
    const path = location.pathname;
    setActiveItem(path);
  }, [location.pathname]);

  // Fetch demandes
  useEffect(() => {
    DemandesAdmin()
      .GetCommande()
      .then((res) => setState({ ...state, demande: res.data }))
      .catch((msg) => setState({ ...state, demande: msg.messageErros }));
  }, []);

  const { demande, messageErros } = state;

  // Track screen width

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  // Render logic based on screen size

  if (screenWidth <= 450) {
    return <SideBarMobile />;
  }

  return (
    <>
      {/* Sidebar for admin */}

      <body>
        <>
      {/* Icône ticket */}
      <i
        className="icon-tick bi bi-ticket-fill"
        onClick={() => setShow(true)}
      ></i>

      {/* Popup */}
      {show && (
        <div className="popup-admin-overlay">
          <div className="popup-admin-container">
            <button className="close-btn" onClick={() => setShow(false)}>
              ×
            </button>

            <div className="popup-admin-header">
              <i className="bi bi-ticket-perforated-fill popup-admin-icon"></i>
              <h2>Créer un Ticket</h2>
              <p>Décrivez votre problème et nous vous aiderons rapidement</p>
            </div>

            <form onSubmit={handleSubmit} className="popup-admin-form">
              <div className="form-group">
                <label>Problème *</label>
                <input
                  type="text"
                  placeholder="Résumez brièvement votre problème..."
                  value={problem}
                  onChange={(e) => setProblem(e.target.value)}
                  required
                />
              </div>

              <div className="form-group">
                <label>Description du problème *</label>
                <textarea
                  placeholder="Décrivez en détail votre problème..."
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  required
                ></textarea>
              </div>

              <button type="submit" className="submit-btn">
                <i className="bi bi-send"></i> Créer le Ticket
              </button>
            </form>
          </div>
        </div>
      )}
    </>
        <section className="sidebar">
          <a href="#" className="brand">
            <img className="mt-3" src={Logo} />
          </a>
          <br />
          <ul className="side-menu top">
            <li
              className={
                activeItem === "/home" ||
                (activeItem && /^\/articles\/[a-zA-Z0-9]+$/.test(activeItem)) ||
                (activeItem &&
                  /^\/articles\/[a-zA-Z0-9]+\/edit$/.test(activeItem))
                  ? "active"
                  : ""
              }
            >
              <Link className="active" to="/home">
                <a href="#" className="menu-item">
                  <i className="bi bi-menu-button-wide-fill" />
                  <span className="menu-text">Accueil</span>
                </a>
              </Link>
            </li>
            <li
              className={
                activeItem === "/articles" ||
                activeItem === "/message" ||
                activeItem === "/articles/categories/add"
                  ? "active"
                  : ""
              }
            >
              <Link to="/articles">
                <a href="#" className="menu-item">
                  <i className="bi bi-box-seam" />
                  <span className="menu-text">Articles</span>
                </a>
              </Link>
            </li>
            <li
              className={
                activeItem === "/magasin" ||
                activeItem === "/magasin/add" ||
                (activeItem &&
                  activeItem.startsWith("/magasin/") &&
                  activeItem.endsWith("/edit"))
                  ? "active"
                  : ""
              }
            >
              <Link to="/magasin">
                <a href="#" className="menu-item">
                  <i className="bi bi-shop" />
                  <span className="menu-text">Magasins</span>
                </a>
              </Link>
            </li>
            <li className={activeItem === "/historiques" ? "active" : ""}>
              <Link to="/historiques">
                <a href="#" className="menu-item">
                  <i className="bi bi-clock"></i>
                  <span className="menu-text">Suivi</span>
                </a>
              </Link>
            </li>
            <li className={activeItem === "/demandes" ? "active" : ""}>
              <Link to="/demandes">
                <a href="#" className="menu-item">
                  <i className="bi bi-envelope"></i>
                  <span className="menu-text">Demandes</span>
                  {demande && demande.length > 0 ? (
                    <span className="countNotif">{demande.length}</span>
                  ) : (
                    ""
                  )}
                </a>
              </Link>
            </li>
          </ul>
          <div className="menu-down-admin mt-5">
            <div className="hr">
              <hr />
            </div>
            <ul className="side-menu top">
              <li className={activeItem === "/notifications" ? "active" : ""}>
                <Link to={"/notification"}>
                  <a href="" className="menu-item">
                    <i className="bi bi-bell" />
                    <span className="menu-text">Notifications</span>
                    {Notifications && Notifications.length > 0 ? (
                      <span className="countNotif">{Notifications.length}</span>
                    ) : (
                      ""
                    )}
                  </a>
                </Link>
              </li>
              <li className={activeItem === "/Paramétres" ? "active" : ""}>
                <Link to="/Paramétres">
                  <a href="#" className="menu-item">
                    <i className="bi bi-gear" />
                    <span className="menu-text">Paramètres</span>
                  </a>
                </Link>
              </li>
            </ul>
            <ul className="logout-admin">
              <li className={activeItem === "/logout" ? "active" : ""}>
                <Link to="/logout" className="logout">
                  <a href="#" className="menu-item">
                    <i className="bi bi-box-arrow-left" />
                    <span className="menu-text">Déconnexion</span>
                  </a>
                </Link>
              </li>
            </ul>
          </div>
        </section>
      </body>

      <div className="container">
        <Link className=" icon-assi" to={"/assistance"}>
          <i className="bi bi-headset"></i>
        </Link>
        <Link to={"/ticket"}>
<i
  className="icon-tick bi bi-ticket-fill" style={{cursor:"pointer"}}
></i>
        </Link>
      </div>
    </>
  );
}
